import React from "react";
import ListView from "../ContentDisplay/ListView";
import {CardBody, CardText, CardTitle} from "reactstrap";

const LIST_HEADERS = ["label", "value"];

const Card = ({data}) => {
  const {label = "", value = ""} = data;
  return (
    <CardBody>
      <CardTitle tag="h4">
        Label: <CardText>{label}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Value: <CardText>{value}</CardText>{" "}
      </CardTitle>
    </CardBody>
  );
};

const CustomFieldDisplayTable = ({data}) => {
  return (
    <ListView
      cardContent={Card}
      listHeaders={LIST_HEADERS}
      listItems={data}
      noDataText={"NO CUSTOM FIELDS"}
      tableName="custom-fields-display"
    />
  );
};

export default CustomFieldDisplayTable;
